import React from 'react';

export function renderPatientIdentifier(patient: { displayName?: string; email?: string; id: string }) {
  const hasDisplayName = !!(patient.displayName && patient.displayName.trim().length > 0);
  const mainIdentifier = hasDisplayName 
    ? patient.displayName 
    : (patient.email && patient.email.trim().length > 0 ? patient.email : patient.id.slice(0, 6));
  
  const showSubIdentifier = hasDisplayName && !!(patient.email && patient.email.trim().length > 0);

  return (
    <>
      <strong>{mainIdentifier}</strong>
      {showSubIdentifier && ` (${patient.email})`}
    </>
  );
}
